import { Box } from '@chakra-ui/react';

import { DealLockStatus } from '../../../gql/generated/graphql';

import LockedReasonCard from './LockedReasonCard';

type LockedDealOverlayProps = {
  lockedReason: DealLockStatus | null;
};

const LockedDealOverlay = ({ lockedReason }: LockedDealOverlayProps) => {
  if (!lockedReason) {
    return null;
  }

  return (
    <Box position="fixed" inset={0} zIndex={9999} bg="blackAlpha.600">
      <LockedReasonCard lockedReason={lockedReason} />
    </Box>
  );
};

export default LockedDealOverlay;
